import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "../../lib/api";
import { Wordmark } from "../../components/Layout";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("tnp-admin-token", data.token);
      navigate("/admin");
    } catch {
      toast.error("Identifiants invalides.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-cream flex items-center justify-center px-5">
      <form onSubmit={submit} className="w-full max-w-sm bg-ivory border border-champagne rounded-3xl p-10 shadow-[0_18px_50px_rgba(42,33,29,0.08)]">
        <div className="text-center mb-8"><Wordmark /></div>
        <h1 className="font-serif text-2xl text-ink text-center mb-8">Espace administrateur</h1>
        <div className="space-y-4">
          <input data-testid="admin-email" type="email" required className="input-elegant" placeholder="Email"
            value={email} onChange={(e) => setEmail(e.target.value)} />
          <input data-testid="admin-password" type="password" required className="input-elegant" placeholder="Mot de passe"
            value={password} onChange={(e) => setPassword(e.target.value)} />
          <button data-testid="admin-login-btn" disabled={loading} className="btn-primary w-full disabled:opacity-60">
            {loading ? "Connexion…" : "Se connecter"}
          </button>
        </div>
      </form>
    </div>
  );
}
